<template>
  <div class="psConfigurationLink">
    <i v-if="useIcomoon" :class="icon" class="icon"></i>
    <Icon v-else :icon="icon" class="icon" />
    <router-link :to="to">{{label}}</router-link>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue2";

export default {
  name: 'PsConfigurationLink',
  components: { Icon },
  props: ['icon', 'label', 'to']
  ,
  computed: {
    useIcomoon () {
      return typeof this.icon === 'string' && !this.icon.includes(':')
    }
  }
}
</script>

<style scoped>
  .psConfigurationLink { font-size: 1.1rem; display: flex; justify-content: flex-start;  transition: 0.2s ease}
  a { margin-left: 12px; margin-bottom: 16px; color: #2c3e50; text-decoration: none;}
  a:active, a:hover, a:visited { color: #2c3e50; }
  .psConfigurationLink:hover { transform: translateX(5px); font-weight: bold;}
</style>